import { cloneDeep } from 'lodash';
import { actions } from './actions';
import { mutations } from './mutations';

const defaultState = {
    offline: false,
    isBitsEnabled: false,
};

export const twitchSettings = {
    namespaced: true,
    state: cloneDeep(defaultState),
    actions,
    mutations,
};
